export const ACCOUNT_API_HOST = process.env.ACCOUNT_API_HOST || "";
export const SELL_API_HOST = process.env.SELL_API_HOST || "";
export const ACCOUNT_HOST = process.env.ACCOUNT_HOST || "";
export const SHOP_HOST = process.env.SHOP_HOST || "";
